/* eslint-disable react/forbid-prop-types */
import React, { PureComponent, useState } from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { scrollToTop } from '../../utils/smartutils';

class SelectField extends PureComponent {
  customStyles = {
    control: () => ({
      boxAlign: 'center',
      alignItems: 'center',
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      boxPack: 'justify',
      justifyContent: 'space-between',
      minHeight: 30,
      outline: 0,
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
    }),

    valueContainer: () => ({
      boxAlign: 'center',
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 8,
      paddingRight: 8,
      position: 'relative',
      overflow: 'hidden',
      boxSizing: 'border-box',
    }),

    input: () => ({
      boxSizing: 'content-box',
      width: 2,
      background: 'rgba(0,0,0,0) none repeat scroll 0px center',
      border: '0px none',
      fontSize: 'inherit',
      opacity: 1,
      outline: 'currentcolor none 0px',
      padding: 0,
      height: 30,
    }),
  };

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    isMulti: PropTypes.bool,
    isClearable: PropTypes.bool,
    isDisabled: PropTypes.bool,
    closeMenuOnSelect: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      })
    ),
    onBlur: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      }),
    ]).isRequired,
    t: PropTypes.func.isRequired,
    isOptionDisabled: PropTypes.func,
  };

  static defaultProps = {
    placeholder: '',
    options: [],
    isMulti: false,
    closeMenuOnSelect: true,
    isDisabled: false,
    isClearable: true,
    isOptionDisabled: undefined,
  };

  handleChange = (selectedOption) => {
    const { onChange } = this.props;
    onChange(selectedOption);
  };

  CustomSelectOption = (props) => (
    <components.Option {...props}>
      {props.data.icon && (
        <span className="input-select__icon">{props.data.icon}</span>
      )}
      {props.data.label}
    </components.Option>
  );

  CustomSingleValue = (props) => (
    <components.SingleValue {...props}>
      {props.data.icon && (
        <span className="input-select__icon">{props.data.icon}</span>
      )}
      {props.data.label}
    </components.SingleValue>
  );

  clearable = () => {
    const { isMulti, isClearable } = this.props;
    return !(!isClearable && !isMulti);
  };

  render() {
    const {
      value,
      name,
      placeholder,
      options,
      isMulti,
      closeMenuOnSelect,
      isDisabled,
      t,
      isOptionDisabled,
      onBlur,
    } = this.props;
    return (
      <Select
        name={name}
        value={value}
        isClearable={this.clearable()}
        onChange={this.handleChange}
        options={options}
        clearable={false}
        isMulti={isMulti}
        closeMenuOnSelect={closeMenuOnSelect}
        className="react-select"
        classNamePrefix="react-select"
        styles={this.customStyles}
        placeholder={placeholder}
        isDisabled={isDisabled}
        components={{
          Option: this.CustomSelectOption,
          SingleValue: this.CustomSingleValue,
        }}
        onBlur={onBlur}
        isOptionDisabled={isOptionDisabled}
        noOptionsMessage={() => t('general.no-options')}
      />
    );
  }
}

const renderSelectField = (props) => {
  const {
    input,
    meta,
    options,
    placeholder,
    isMulti,
    isDisabled,
    closeMenuOnSelect,
    t,
    isClearable,
    isOptionDisabled,
  } = props;

  const [message, setMessage] = useState(null);
  const verifySelectField = () => {
    if (meta.error) {
      setMessage(meta.error);
    }
    return null;
  };
  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <SelectField
        {...input}
        options={options}
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={isDisabled}
        closeMenuOnSelect={closeMenuOnSelect}
        t={t}
        isClearable={isClearable}
        isOptionDisabled={isOptionDisabled}
        onBlur={verifySelectField}
      />
      {message && <span className="form__form-group-error">{meta.error}</span>}
      {meta.submitFailed && meta.error && (
        <span className="form__form-group-error">
          {meta.error}
          {scrollToTop()}
        </span>
      )}
    </div>
  );
};

renderSelectField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ),
  isMulti: PropTypes.bool,
  isDisabled: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  t: PropTypes.func.isRequired,
  isClearable: PropTypes.bool,
  isOptionDisabled: PropTypes.func,
};

renderSelectField.defaultProps = {
  meta: null,
  options: [],
  placeholder: '',
  isMulti: false,
  closeMenuOnSelect: true,
  isDisabled: false,
  isClearable: true,
  isOptionDisabled: undefined,
};

export default withTranslation('common')(renderSelectField);
